export default "__VITE_ASSET__Cl$CHtdw__"